import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {PaginationInterface} from '../../interfaces/responses/pagination.interface';
import {toHttpParams} from '../../utils/app.util';
import {Category, CategoryQueryParams} from '../../interfaces/responses/category.interface';


const env = environment;

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private http = inject(HttpClient);

  storeCategory(data: { name: string; description: string }): Observable<Category> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/categories`;

    return this.http.post<Category>(url,
      data, {
        headers: {
          Authorization: `Bearer ${token ?? ''}`,
          'Content-Type': 'application/json',
        }
      },
    ).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error creating category ${error}`));
      })
    );
  }

  fetchCategories(queryParams: CategoryQueryParams): Observable<PaginationInterface<Category[]>> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/categories`;
    return this.http.get<PaginationInterface<Category[]>>(url, {
      params: toHttpParams(queryParams),
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error fetching categories ${error}`));
      })
    );
  }


  updateCategory(id: string, data: Category): Observable<Category> {
    let token: string | null = null;
      if (typeof window !== 'undefined') {
        token = localStorage.getItem('tokenn');
      }
    const url = `${env.apiUrl}/categories/${id}`;
    return this.http.put<Category>(url,
      data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
    },
  ).pipe(
    catchError((error) => {
      return throwError(() => new Error(`Error updating category ${error}`));
    })
  );
  }

  toggleStatus(id: string): Observable<Category> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/categories/${id}/status`;
    return this.http.patch<Category>(url, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error toggling category status ${error}`));
      })
    );
  }

  deleteCategory(id: string): Observable<Category> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/categories/${id}`;
    return this.http.delete<Category>(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error deleting category ${error}`));
      })
    );
  }
}
